module.exports = __webpack_public_path__ + "img/nut-pecans-350x184.da469f76.jpg";